import {Button, Dropdown, Menu, Typography} from "antd";
import {PERMISSIONS, useUser} from "../../../core/context/UserContext";
import {v4} from "uuid";
import {t} from "i18next";
import ApiService from "../../../core/service/api-service";
import {useDataGrid} from "../../../core/components/data-grid/DataGridContext";
import {useModal} from "../../../core/context/ModalContext";
import RowMenu from "../../../core/components/data-grid/RowMenu";
import {Pages} from "../../../AppRouter";

export default function HL7RequestRowMenu({text, row})
{
    const {hasPermission} = useUser();
    const {refreshDataGrid} = useDataGrid()
    const {openModal, closeModal} = useModal()

    return (
        <RowMenu text={text}>
            {
                hasPermission(PERMISSIONS.HOSPITAL_MANAGER) && (
                    <Menu>
                        <Menu.Item
                            key={v4()}
                            onClick={async () => {
                                const res = await ApiService.HL7Service.GetHL7ClientDataGrid(row.id)
                                if(res.success) {
                                    openModal('Message', (
                                        <>
                                            <Typography.Text copyable={true} style={{whiteSpace: 'pre-wrap'}}>
                                                {res.data}
                                            </Typography.Text>
                                        </>
                                    ))
                                }
                            }}
                        >
                            {t('Open Message')}
                        </Menu.Item>
                        <Menu.Item
                            key={v4()}
                            onClick={async () => {
                                const res = await ApiService.HL7Service.ManualProcess(row.id)
                                if(res.success) {
                                    await refreshDataGrid()
                                }
                            }}
                        >
                            {t('Manual Process')}
                        </Menu.Item>
                    </Menu>
                )
            }
        </RowMenu>
    )
}